import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Slider from 'react-slick';
import Link from 'react-router/lib/Link';
import {map} from 'lodash';
import classNames from 'classnames';
import { isInternalLink } from '../../../utils/link.js';
import { SHOPPING_HOME_CAROUSEL } from './../shopping_modules_data';

const MAX_WIDTH = 9999999;
const MOBILE_BREAKPOINT = 760;
export const DISPLAY_AS_LOADED_DELAY = 500;

const SLIDER_PROPS = {
  className: 'carousel-items',
  infinite: true,
  dots: true,
  slidesToScroll: 1,
  slidesToShow: 1,
  initialSlide: 0,
  centerMode: true,
  draggable: true,
  variableWidth: false,
  lazyLoad: false,
  speed: 1000,
  autoplaySpeed: 5000,
  touchThreshold: 30,
  touchMove: false,
  centerPadding: 0,
  autoplay: true,
  responsive: [

    /*
     * Mobile
     */

    {
      breakpoint: MOBILE_BREAKPOINT,
      settings: {
        arrows: false
      }
    },

    /*
     * Desktop & Tablet
     */

    {
      breakpoint: MAX_WIDTH,
      settings: {
        arrows: true
      }
    }
  ]
};

export const CarouselSlide = ({ image, overlay, text, link, product_count,
  call_to_action, collection_meta }) => {
  const innerSlide = (
    <div className="carousel-slide">
      <div className="background">
        <img src={image} />
      </div>
      <div className="overlay">
        <img src={overlay} />
        <div className="collection-meta" dangerouslySetInnerHTML={{ __html: collection_meta }} />
        <div className="subtitle" >
          <span className="call-to-action" dangerouslySetInnerHTML={{ __html: `${call_to_action} ` }} />
          <span className="description" dangerouslySetInnerHTML={{ __html: text }} />
        </div>
        {product_count &&
          <div className="product-count" dangerouslySetInnerHTML={{ __html: `${product_count} products` }} />
        }
      </div>
    </div>
  );

  return (
    <div>
      {
        !isInternalLink(link) ?
          (
            <a href={link}>
              {innerSlide}
            </a>
          )
          : (
            <Link to={link}>
              {innerSlide}
            </Link>
          )
      }
    </div>
  );

};

CarouselSlide.propTypes = {
  image: PropTypes.string.isRequired,
  overlay: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  product_count: PropTypes.string,
  call_to_action: PropTypes.string,
  collection_meta: PropTypes.string
};

export default class ProductListHomeCarousel extends Component {
  constructor(props) {
    super(props);

    this.state = { isLoaded: false };
  }


  componentDidMount() {
    if (!this.state.isLoaded) {
      this._timeout = window.setTimeout(() => {
        this.setState({ isLoaded: true });

        /*
         * Hack for react-slick and React v16
         *   Force resize event for the carousel when loading to account
         *   for slides with dynamic widths based on the viewport width.
         *   See PR this was introduced with for links to react-slick issues
         *   This solution is a play on:
         *     https://github.com/akiran/react-slick/issues/809#issuecomment-317277508
         */
        if (this._carousel.innerSlider) {
          this._carousel.innerSlider.onWindowResized();
        }
      }, DISPLAY_AS_LOADED_DELAY);
    }
  }

  componentWillUnmount = () =>
    window.clearTimeout(this._timeout);

  render() {
    const { pageTitle } = this.props;

    const wrapperClass = classNames('shopping-home-carousel-wrapper', { 'loading': !this.state.isLoaded });
    return (
      <div className={wrapperClass}>
        <h1 className="title" dangerouslySetInnerHTML={{ __html: pageTitle }} />
        <Slider ref={node => this._carousel = node} {...SLIDER_PROPS}>
          {
            map(SHOPPING_HOME_CAROUSEL, ({ title, ...props }) =>
              <CarouselSlide key={title} {...props} />
            )
          }
        </Slider>
      </div>
    );
  }
}

ProductListHomeCarousel.propTypes = {
  pageTitle: PropTypes.string
};
